module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main', {
    staticClass: "flex bg-white new-shadow-theme br3 custom-padding responsive-box",
    class: _vm.modalVisible ? 'blur-background' : ''
  }, [_c('div', {
    staticClass: "flex flex-column w-100 responsive-plan"
  }, [_c('div', {
    staticClass: "cera-round-pro-medium f4 mb3 fw5"
  }, [_vm._v("Special Offer for AKKO Members!")]), _vm._v(" "), _c('div', {
    staticClass: "inter mb1 f6 self-center items-center justify-start text-container"
  }, [_vm._v("\n        You've taken the first step to protect your devices from physical harm,\n        but don't forget to add this great offer to protect your digital identity and wellbeing\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "container pointer flex flex-column w-100-mobile br3 pa4 mt3 h-100 relative",
    class: _vm.includeOpen ? 'mb3 mb5-l' : 'mb4 mb6-l'
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row-l flex-column justify-between plan-card"
  }, [_c('plan-card-upsell', {
    staticClass: "plan-card-inner",
    attrs: {
      "title": "CyberScout",
      "isCyberScout": true,
      "includeOpen": _vm.includeOpen,
      "planInfoStrings": _vm.cyberScoutStrings,
      "content": "$1M identify theft protection + ransomware protection"
    }
  }), _vm._v(" "), _c('plan-card-upsell', {
    staticClass: "plan-card-inner",
    attrs: {
      "title": "Dashlane Premium",
      "isCyberScout": false,
      "includeOpen": _vm.includeOpen,
      "planInfoStrings": _vm.dashLaneStrings,
      "content": "Premium password manager + VPN service & dark web monitoring"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "red-tick"
  }, [_c('red-tick-icon', {
    staticClass: "mr2"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt2 upsell-toggle"
  }, [_c('upsell-plan-info', {
    attrs: {
      "toggleInclude": _vm.toggleInclude,
      "includeOpen": _vm.includeOpen
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex price-responsive justify-between"
  }, [_c('div', {
    staticClass: "flex flex-row items-center text-price-responsive"
  }, [_c('upsell-prices', {
    attrs: {
      "upsellRetailPrice": _vm.upsellRetailPrice,
      "upsellCurrentPrice": _vm.upsellCurrentPrice,
      "interval": _vm.productPrice.interval
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "tc flex justify-center"
  }, [_c('ak-button', {
    staticClass: "button-responsive mr3",
    attrs: {
      "newSecondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.finishUpsell(false)
      }
    }
  }, [_vm._v("\n              Skip for now\n            ")]), _vm._v(" "), _c('ak-button', {
    staticClass: "button-responsive",
    attrs: {
      "newPrimary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showModal.apply(null, arguments)
      }
    }
  }, [_vm._v("\n              Add to My Plan\n            ")])], 1)])])])]), _vm._v(" "), (_vm.modalVisible) ? _c('modal-without-inner-border', {
    attrs: {
      "upsell": "",
      "title": "Confirm Add-On Purchase"
    },
    on: {
      "close": _vm.hideModal
    }
  }, [_c('form', {
    staticClass: "flex-ns flex-wrap",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mt3 mb2 f6 mh3-ns gray-text"
  }, [_vm._v("\n        Upon confirming, the bundled add-on plan will be instantly added to your account followed by instructions on how to set it up. Are you sure you want to continue?\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "pb4 ph3 mt2 flex flex-wrap justify-between justify-end-ns upsell-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('ak-button', {
    staticClass: "button-responsive mr3",
    attrs: {
      "newSecondary": "",
      "upsell": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        Skip for now\n      ")]), _vm._v(" "), _c('ak-button', {
    staticClass: "button-responsive",
    attrs: {
      "newPrimary": "",
      "upsell": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.finishUpsell(true)
      }
    }
  }, [_vm._v("\n        Add to my plan\n      ")])], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cera-round-pro-medium f5 mb3 fw5 mb3 plan-title"
  }, [_vm._v("\n          Bundled Plan  \n          "), _c('span', {
    staticClass: "inter gray-text f6"
  }, [_vm._v("CyberScout + Dashlane Premium")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-17a6a0dc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17a6a0dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/upsell/SelectUpsell.vue
// module id = 1128
// module chunks = 0